:host {
  position: absolute;
  z-index: var(--sc-cart-z-index, 999999);
  font-family: var(--sc-font-sans);
}
